const completionSpec: Fig.Spec = {
	name: "time",
	description: "Time how long a command takes!",
	args: {
		isCommand: true,
	},
};

export default completionSpec;
